module.exports = __webpack_public_path__ + "media/hero-video.bfc72925.mp4";